const fullNameRegex = /^([\p{L} .'()-])*$/u // Matches any Unicode letter (which includes letters with diacritics like é, ö, ñ, etc.).
const usernameRegex = /^([a-zA-Z0-9_.])*$/

export { fullNameRegex, usernameRegex }
